import { useCallback, useRef } from 'react';
import type { Entity } from '../types';
import type { GoodsData } from '@banhala/ui-kit';
import type { FlatListProps } from 'react-native';
import { bridge, isNotNil } from '../../../../../utils';
import { AdAction } from '../../../../../utils/eventLogger/adLogger/types';

export const useLogDisplayGoods = () => {
  const goodsItemLoggedList = useRef<Array<number>>([]);

  const logDisplayGoods = useCallback<
    NonNullable<FlatListProps<GoodsData & Entity>['onViewableItemsChanged']>
  >(({ viewableItems }) => {
    viewableItems.forEach(({ index, isViewable, item }) => {
      if (index === null || !isViewable) {
        return;
      }
      if (goodsItemLoggedList.current.includes(index)) {
        return;
      }
      goodsItemLoggedList.current.push(index);

      bridge.logAnalyticsEvent({
        name: 'DISPLAY_GOODS',
        logging: item.logging,
      });

      if (isNotNil(item.item.ad)) {
        bridge.logAdEvent({
          action: AdAction.DISPLAY,
          ad: item.item.ad,
        });
      }
    });
  }, []);

  return { logDisplayGoods };
};
